<template>
    <div
        class="image-container center-x"
        :class="{ 'px-5 py-3': contained, 'app-image': isApp(), 'placeholder-icon': !imageLink }"
    >
        <img
            v-if="imageLink"
            class="product-image"
            alt=""
            :src="(imageLink.startsWith('/')) ? `https://app.octopusorder.com${imageLink}` : imageLink"
        />
        <ion-icon v-else src="assets/icon/item.svg" class="purple-purple-color" style="height: 100%; width: 100%"/>
    </div>
</template>

<script setup lang="ts">
import { IonIcon } from "@ionic/vue";

import { ImageLinkProps } from "@/types/props";
import { isApp } from "@/functions/enviroment";

defineProps<ImageLinkProps>()
</script>

<style scoped>
.image-container {
    height: 100%;
    width: 100%;
    min-width: 300px;
    max-height: 100%;
    max-width: 100%;
}

.image-container.app-image {
    height: auto;
    width: auto;
    min-height: 300px;
}

.product-image {
    height: auto;
    width: auto;
    object-fit: contain;
}

.adapt-image .image-container:not(.app-image) {
    min-width: 100%;
}

.contain-within-300.image-container .product-image {
    height: 100%;
    max-height: 300px;
}

.image-container.app-image.placeholder-icon {
    width: 100%;
    height: 300px;
}

@media only screen and (min-width: 768px) and (min-height: 768px) {
    .image-container.app-image {
        height: 100%;
        max-height: 300px;
    }
}
</style>
